import React, { useEffect, useRef } from "react";

import PageHeading from "../../../../../components/PageHeading";

import { useIsNewNavigation } from "../../../../../api/hooks/defs/navigation";

//template
import InfoPageTemplate from "../../../../../pageTemplates/InfoPageTemplate";
import { CompanyReviewsNavigationLinks } from "../../constants";

const PAGE_TITLE = "Performance Graphs";

const PerformanceGraphsWrapper = () => {
	const containerRef = useRef(null);
	const isNewNav = useIsNewNavigation();

	/*
	 * Here we are getting the goals dashboard from a hidden div'd element in the tornado template that is generated server side.
	 * We are then taking element and appending it to the containerRef.current element.
	 * We're then hiding the original and using the clones element for display when the user navigates to the dashboard page.
	 */
	useEffect(() => {
		$("#tornado-template-content").show();
		$("#reviews-dashboard").show();
		$("#reviews-dashboard").css("visibility", "visible");
		if (containerRef.current) {
			$("#reviews-dashboard").appendTo(containerRef.current);
		}
	}, []);

	const mainContent = <div ref={containerRef} />;

	return (
		<InfoPageTemplate
			pageTitle={PAGE_TITLE}
			pageHeading={isNewNav ? <PageHeading>{PAGE_TITLE}</PageHeading> : undefined}
			mainContent={mainContent}
			navigationLinks={CompanyReviewsNavigationLinks}
			activeNavigationLinkKey={"graphs"}
		/>
	);
};

export default PerformanceGraphsWrapper;
